 <ng-container [ngSwitch]="userType">
    <app-servicenear-side-menu *ngSwitchCase="'servicenear'"></app-servicenear-side-menu>
    <app-tobeonline-side-menu *ngSwitchCase="'tobeonline'"></app-tobeonline-side-menu>
 </ng-container>
